import { render, staticRenderFns } from "./contentTitle.vue?vue&type=template&id=86ac685e&scoped=true&"
import script from "./contentTitle.vue?vue&type=script&lang=js&"
export * from "./contentTitle.vue?vue&type=script&lang=js&"
import style0 from "./contentTitle.vue?vue&type=style&index=0&id=86ac685e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ac685e",
  null
  
)

export default component.exports